import React from 'react';
import './Page.less';
import './Model.less';
import '../components/Table.less';
import BackBtn from '../components/UI/BackBtn';

// const cmpData = [
//   {
//     title: 'Публикации Q1-Q2 Wos CC',
//     rows: [{ institution: 'Arizona State', progress: 100 }, { institution: 'Yonsei', progress: 97 }, { institution: 'TsingHua', progress: 90 }, { institution: 'HIT*', progress: 90 }, { institution: 'Sungkyunkwan', progress: 80 }, {
//       institution: 'УрФУ', progress: 55, progressThirty: 70, value: '70%',
//     }],
//   },
//   {
//     title: 'Объем НИОКР на 1 НПР',
//     rows: [{ institution: 'НИУ ВШЭ', progress: 100 }, { institution: 'МГТУ им. Н.Э.Баумана', progress: 95 }, { institution: 'СПбПУ', progress: 70 }, {
//       institution: 'УрФУ', progress: 55, progressThirty: 66, value: '919',
//     }, { institution: 'МГУ', progress: 59 }, { institution: 'КФУ', progress: 55 }],
//   },
//   {
//     title: 'Публикации Wos CC',
//     rows: [{ institution: 'TsingHua', progress: 100 }, { institution: 'HIT*', progress: 65 }, { institution: 'Yonsei', progress: 59 }, { institution: 'Sungkyunkwan', progress: 50 }, { institution: 'Arizona State', progress: 45 }, {
//       institution: 'УрФУ', progress: 23, progressThirty: 43, value: '4290',
//     }],
//   },
//   {
//     title: 'Аспиранты',
//     rows: [{ institution: 'МГУ', progress: 100 }, {
//       institution: 'УрФУ', progress: 35, progressThirty: 49, value: '1700',
//     }, { institution: 'КФУ', progress: 47 }, { institution: 'НИУ ВШЭ', progress: 44 }, { institution: 'СПбПУ', progress: 40 }, { institution: 'МГТУ им. Н.Э.Баумана', progress: 40 }],
//   },
//   {
//     title: 'Публикации Wos за 5 лет в топ-1%',
//     rows: [{ institution: 'TsingHua', progress: 100 }, { institution: 'HIT*', progress: 40 }, { institution: 'Yonsei', progress: 36 }, { institution: 'Arizona State', progress: 35 }, { institution: 'Sungkyunkwan', progress: 35 }, {
//       institution: 'УрФУ', progress: 10, progressThirty: 25, value: '200',
//     }],
//   },
//   {
//     title: 'Доля внебюджетных НИОКР',
//     rows: [{
//       institution: 'УрФУ', progress: 90, progressThirty: 100, value: '66.7%',
//     }, { institution: 'СПбПУ', progress: 95 }, { institution: 'МГУ', progress: 90 }, { institution: 'НИУ ВШЭ', progress: 70 }, { institution: 'МГТУ им. Н.Э.Баумана', progress: 50 }, { institution: 'КФУ', progress: 40 }],
//   },
// ];
// const cmpData2 = [
//   {
//     title: 'Численность студентов очной формы',
//     rows: [{
//       institution: 'УрФУ', progress: 70, progressThirty: 100, value: '35800',
//     }, { institution: 'МГУ', progress: 95 }, { institution: 'НИУ ВШЭ', progress: 90 }, { institution: 'КФУ', progress: 80 }, { institution: 'СПбБУ', progress: 60 }, { institution: 'МГТУ им. Н.Э.Баумана', progress: 55 }],
//   },
//   {
//     title: 'Доля магистрантов и аспирантов',
//     rows: [{ institution: 'МГУ', progress: 100 }, {
//       institution: 'УрФУ', progress: 60, progressThirty: 93, value: '30%',
//     }, { institution: 'НИУ ВШЭ', progress: 85 }, { institution: 'СПбБУ', progress: 60 }, { institution: 'КФУ', progress: 50 }, { institution: 'МГТУ им. Н.Э.Баумана', progress: 45 }],
//   },
//   {
//     title: 'Средний балл ЕГЭ',
//     rows: [{ institution: 'МГУ', progress: 100 }, { institution: 'НИУ ВШЭ', progress: 98 }, { institution: 'МГТУ им. Н.Э.Баумана', progress: 90 }, { institution: 'СПбБУ', progress: 86 }, { institution: 'КФУ', progress: 82 }, {
//       institution: 'УрФУ', progress: 73, progressThirty: 80, value: '80',
//     }],
//   },
//   {
//     title: 'Доля иностранных студентов',
//     rows: [{
//       institution: 'УрФУ', progress: 70, progressThirty: 100, value: '20%',
//     }, { institution: 'КФУ', progress: 99 }, { institution: 'СПбБУ', progress: 90 }, { institution: 'МГУ', progress: 60 }, { institution: 'НИУ ВШЭ', progress: 57 }, { institution: 'МГТУ им. Н.Э.Баумана', progress: 30 }],
//   },
// ];
const tableModel = [
  {
    th: 'I этап – локализация цепочек создания и внедрения критических и сквозных технологий', title: 'Субъект формирования региональной повестки', year: '2024', content: [{ value: '4', description: 'млрд руб. НИОКТР ' }, { value: '70%', description: 'доля прикладных НИР' }, { value: '22 000', description: 'студентов инженерных направлений*' }, { value: '78,9', description: 'средний балл ЕГЭ по отраслевому направлению**' }],
  },
  {
    title: 'Платформа развития центров компетенций', year: '2030', content: [{ value: '8,1', description: 'млрд руб. НИОКТР' }, { value: '74%', description: 'доля прикладных НИР' }, { value: '29 500', description: 'студентов инженерных направлений*' }, { value: '80,0', description: 'средний балл ЕГЭ по отраслевому направлению**' }],
  },
  {
    th: 'II этап – центр технологического лидерства', ul: ['Атомная энергетика и промышленность', 'Цифровизация и роботизация производств', 'Машиностроение', 'Металлургия'], year: '2036', content: [{ value: '16,3', description: 'млрд руб. НИОКТР' }, { value: '78%', description: 'доля прикладных НИР' }, { value: '30 000', description: 'студентов инженерных направлений*' }, { value: '82,0', description: 'средний балл ЕГЭ по отраслевому направлению**' }],
  },
];
const vectorsTableData = {
  caption: 'Ключевые изменения в процессе исследований и разработок',
  headings: ['№', 'Ключевые изменения'],
  rows: [
    'Фокусировка на доведении разработок до УГТ ≥ 6 и рост научно-исследовательских и опытно-конструкторских работ, научно-технических и производственных услуг до 16,3 млрд руб. к 2036 г. Для реализации ключевых научно-технических направлений, в т.ч.  стратегических инициатив, будут отобраны и назначены ответственные за реализацию ключевых научно-технических направлений («главные конструкторы»).',
    'Масштабирование возможностей и ресурсов для развития инновационной деятельности и технологического предпринимательства. Ключевым приоритетом в 2025–2030 гг. является задача по созданию расширенной модели НИОКТР, ориентированной на достижение совместных результатов в рамках научно-производственных объединений, дочерних и совместных предприятий при оценке вклада в НПТЛ. К 2030 году объем выручки от инжиниринговых и производственных услуг должен достигнуть не менее 2,5 млрд руб. в год, к 2036 году не менее 3,5 млрд. руб.',
    'Усиление и развитие системы подготовки научно-исследовательских и инженерных кадров высшей квалификации, включая создание производственной аспирантуры. Базовый индикатор изменений – увеличение к 2036 году доли выпускников, защитивших диссертации не позднее одного года с момента завершения обучения до 60%.',
    'Концентрация фундаментальных и прикладных исследований на фронтирных направлениях. Базовые индикаторы – увеличение доли публикаций в изданиях, отнесенных к I и II квартилям, до 70% при сохранении высоких темпов роста научной продуктивности университета, экспертиза 100% научно-исследовательских проектов, реализуемых в рамках программы развития университета, с участием представителей РАН и предприятий.',
    'Углубление процесса интеграции Университета с Уральским отделением Российской академии наук при проведении фундаментальных исследований по ключевым научным направлениям стратегии (к 2030 году количество совместных с институтами УрО РАН научных лабораторий по критическим и сквозным технологиям – не менее 10 ед.).',
  ],
};
const vectorsEduTableData = {
  caption: 'Ключевые изменения модели высшего образования',
  headings: ['№', 'Ключевые изменения'],
  rows: [
    'Совершенствование системы отбора и развития талантливых студентов на базе механизма индивидуальных траекторий обучения',
    'Продвижение образовательных программ на международные образовательные рынки для усиления академической репутации и повышения финансовой устойчивости университета.',
    'Усиление фундаментальной составляющей образования для подготовки специалистов, обладающих глубокими знаниями в естественно-научной области и математике, владеющих передовыми цифровыми навыками, имеющих целостное представление о развитии технологий и способных к решению инновационных задач',
    'Расширение и укрепление взаимодействия Университета с организациями-партнерами (органами государственной власти субъектов Российской Федерации, организациями и предприятиями реального сектора экономики и социальной сферы, научными организациями и др.) с целью актуализации содержания образовательных программ и усиления практической составляющей обучения. Введение в состав образовательных программ дополнительных модулей, в том числе от ведущих предприятий реального сектора экономики, IT-компаний, центров компетенций УрФУ и др., обеспечивающих адаптацию выпускников к их будущей профессиональной деятельности;',
    'Создание условий для освоения студентами дополнительных квалификаций в период освоения основной образовательной программы.',
    'Сокращение сроков освоения образовательных программ по востребованным на рынке направлениям подготовки с целью раннего выхода студентов на рынок труда, в том числе за счет дуального обучения.',
    'Расширение практики реализации проектного обучения студентов, вовлечения работодателей, научных и инновационных подразделений Университета в учебные проекты.',
    'Расширение образовательных возможностей обучающихся за счет использования ресурсов других университетов путем сетевого взаимодействия и использования открытых курсов, в том числе на международных платформах открытого образования, при реализации образовательных программ.',
    'Воспитание профессиональной идентичности студентов, патриотизма и гражданской ответственности через профориентацию в школе (в т.ч. СУНЦ), обучение служением и деятельностные образовательные технологии раннего входа в профессию, в т.ч. обучение на базе реальных проектов, работы с наставниками-практиками и прохождение стажировок и практик в передовых предприятиях отрасли и центрах разработок.',
    'Непрерывное повышение эффективности и обеспечение высокого качества образовательного процесса за счет внедрения новых образовательных технологий (онлайн-составляющих учебного процесса, технологий «перевернутого класса», дистанционных «гостевых» лекций). Снижение инфраструктурных ограничений и повышение качества обучения путем переноса практико- ориентированной части образовательного процесса на территорию предприятий-партнеров.',
  ],
};

const renderTable = (data) => {
  return (
  <div className="table table-special2">
    <div className="heading">{data.caption}</div>
    <table>
      <thead>
        <tr>
          {data.headings.map((item, i) =>
            <th key={i} style={{ padding: '16px' }}><span>{item}</span></th>)}
        </tr>
      </thead>
      <tbody>
        {data.rows.map((row, i) => (
          <tr key={i}>
            <td><span style={{ padding: '16px' }}>{i + 1}.</span></td>
            <td><span className="index">{row}</span></td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>)
}

// Данные для таблицы целевой модели УрФУ
const targetModelData = {
  caption: "Параметры целевой модели УрФУ",
  headers: ["Параметры целевой модели УрФУ", "Ед. изм.", "2024", "2030", "2036"],
  sections: [
    {
      name: "Образование",
      rows: [
        { parameter: "Численность студентов очной формы обучения", unit: "чел.", values: ["38 458", "49 500", "50 000"] },
        { parameter: "в т.ч. по инженерным направлениям", unit: "чел.", values: ["22 443", "29 500", "30 000"] },
        { parameter: "Средний балл ЕГЭ (бюджет + контракт)", unit: "балл", values: ["71,68", "73", "74,5"] },
        { parameter: "в т.ч. по инженерным направлениям", unit: "балл", values: ["72,73", "74,5", "77"] },
        { parameter: "в т.ч. по образовательным программам в интересах ГК «Росатом»", unit: "балл", values: ["72,49", "77", "80"] },
        { parameter: "Доля иностранных студентов (очный контингент)", unit: "%", values: ["9,3", "12", "15"] },
        { parameter: "доля иностранных студентов в численности инженерных направлений (очный контингент)", unit: "%", values: ["8,9", "12", "15"] }
      ]
    },
    {
      name: "Исследовательская и инновационная деятельность",
      rows: [
        { parameter: "Объем НИОКТР и НТУ", unit: "млн руб.", values: ["4 002", "8100", "16 290"] },
        { parameter: "Доля прикладных НИОКТР, %", unit: "%", values: ["70%", "74%", "78%"] },
        { parameter: "Справочно: объем НИОКТР и НТУ с учетом научно-производственных объединений (НПО)", unit: "", values: ["-", "12 100", "28 300"] }
      ]
    },
    {
      name: "Кадры",
      rows: [
        { parameter: "Доля НПР в возрасте до 39 лет", unit: "%", values: ["38%", "40%", "42%"] },
        { parameter: "в т.ч. по инженерным направлениям", unit: "%", values: ["42%", "44%", "46%"] },
        { parameter: "доля остепенённых НПР в общей численности НПР до 39 лет", unit: "%", values: ["44%", "47%", "55%"] }
      ]
    },
    {
      name: "Инфраструктура",
      rows: [
        { parameter: "Площадь учреждения", unit: "тыс. м2", values: ["676", "777", "777"] },
        { parameter: "в т.ч. кампус мирового уровня", unit: "тыс. м2", values: ["234", "335", "335"] }
      ]
    },
    {
      name: "Трансформация системы управления",
      rows: [
        { parameter: "Количество главных конструкторов по ключевым научнотехнологическим направлениям", unit: "чел.", values: ["-", "5", "7"] },
        { parameter: "Средний объем НИОКТР на 1 главного конструктора", unit: "млрд руб.", values: ["-", "0,3", "0,7"] }
      ]
    }
  ]
};

// Данные для таблицы выпуска инженерных кадров и объема НИОКТР
const engineeringOutputData = {
  caption: "Вклад УрФУ в достижение задач национальных проектов технологического лидерства*",
  headers: ["Параметр", "2025-2030", "2031-2036"],
  sections: [
    {
      name: "Выпуск инженерных кадров (всего), чел.",
      rows: [
        { parameter: "в т.ч. линейные инженеры", values: ["20 950", "26 200"] },
        { parameter: "инженеры-разработчики", values: ["6 800", "8 500"] },
        { parameter: "инженеры-исследователи", values: ["900", "1 150"] },
        { parameter: "технологические предприниматели", values: ["500", "750"] }
      ],
      totals: ["28 750", "36 000"]
    },
    {
      name: "Объем выполненных НИОКТР, млрд руб.",
      rows: [
        { parameter: "в т.ч. НПТЛ «Средства производства и автоматизации»", values: ["8,0", "12,0"] },
        { parameter: "НПТЛ «Промышленное обеспечение транспортной мобильности»", values: ["7,0", "10,0"] },
        { parameter: "НПТЛ «Новые материалы и химия»", values: ["4,0", "6,0"] },
        { parameter: "НПТЛ «Новые атомные и энергетические технологии»", values: ["1,5", "2,0"] },
        { parameter: "НПТЛ «Новые технологии сбережения здоровья»", values: ["1,2", "2,0"] }
      ],
      totals: ["32,0", "45,0"]
    }
  ]
};

// Компонент для отображения таблицы целевой модели
const TargetModelTable = () => {
  return (
    <div className="table table-special2 extra-table">
      <div className="heading">{targetModelData.caption}</div>
      <table>
        <thead>
          <tr>
            {targetModelData.headers.map((header, index) => (
              <th key={index} style={{ padding: '16px', textAlign: index > 1 ? 'center' : 'left' }}><span>{header}</span></th>
            ))}
          </tr>
        </thead>
        <tbody>
          {targetModelData.sections.map((section, sectionIndex) => (
            <React.Fragment key={sectionIndex}>
              <tr>
                <td colSpan={5} style={{ textAlign: 'center', backgroundColor: '#f1f1f1' }} className="section-header"><span>{section.name}</span></td>
              </tr>
              {section.rows.map((row, rowIndex) => (
                <tr key={`${sectionIndex}-${rowIndex}`}>
                  <td><span>{row.parameter}</span></td>
                  <td><span>{row.unit}</span></td>
                  {row.values.map((value, valueIndex) => (
                    <td style={{ textAlign: 'center' }} key={valueIndex}><span>{value}</span></td>
                  ))}
                </tr>
              ))}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// Компонент для отображения таблицы выпуска инженерных кадров и НИОКТР
const EngineeringOutputTable = () => {
  return (
    <div className="table table-special2 extra-table">
      <div className="heading">{engineeringOutputData.caption}</div>
      <table>
        <thead>
          <tr>
            {engineeringOutputData.headers.map((header, index) => (
              <th key={index} style={{ padding: '16px', textAlign: index > 0 ? 'center' : 'left' }}><span>{header}</span></th>
            ))}
          </tr>
        </thead>
        <tbody>
          {engineeringOutputData.sections.map((section, sectionIndex) => (
            <React.Fragment key={sectionIndex}>
              <tr>
                <td style={{ backgroundColor: '#f1f1f1' }}><span>{section.name}</span></td>
                {section.totals.map((total, totalIndex) => (
                  <td key={totalIndex} style={{ textAlign: 'center', backgroundColor: '#f1f1f1' }}><span>{total}</span></td>
                ))}
              </tr>
              {section.rows.map((row, rowIndex) => (
                <tr key={`${sectionIndex}-${rowIndex}`}>
                  <td><span>{row.parameter}</span></td>
                  {row.values.map((value, valueIndex) => (
                    <td key={valueIndex} style={{ textAlign: 'center' }}><span>{value}</span></td>
                  ))}
                </tr>
              ))}
            </React.Fragment>
          ))}
        </tbody>
      </table>
      <div className="table-note">
        <span>
        * без учета деятельности ассоциированных с университетом партнерств (НПО, консорциумы) и/или малых инновационных предприятий.
        </span>
      </div>
    </div>
  );
};

export default function Model() {
  return (
    <section className="page model-page">
      <div className="container">
        <BackBtn />
        <div className="table table-special1">
          <div className="heading">Целевая модель</div>
          <div className="table-wrapper">
            <table>
              <thead>
                <tr>
                  <th colSpan="2">{tableModel[0].th}</th>
                  {tableModel.slice(2).map((item, i) =>
                    <th key={i}>
                      <div className="title">{item.th}</div>
                      <ul>
                        {item.ul.map((item, i) => (
                          <li key={i}>
                            {item}
                          </li>
                        ))}
                      </ul>
                    </th>
                  )}
                </tr>
              </thead>
              <tbody>
                <tr>
                  {tableModel.map((item, i) => (
                    <td key={i}>
                      <p className="title">{item.title}</p>
                      <p className="year">{item.year}</p>
                      <ul>
                        {item.content.map((contentItem, i) => (
                          <li key={i}>
                            <span className="content-value">{contentItem.value}</span>
                            <span className="content-description">{contentItem.description}</span>
                          </li>
                        ))}
                      </ul>
                      {i === 2 && (
                        <div className='mechanisms'>
                          <div className='mechanisms-title'>
                            <span>МЕХАНИЗМЫ</span>
                          </div>
                          <ul className='mechanisms-list'>
                            <li>Фабрика технологий</li>
                            <li>Новая академическая среда</li>
                            <li>Новая модель инженерного и ИТ образования</li>
                          </ul>
                        </div>
                      )}
                    </td>
                  ))}
                </tr>
              </tbody>
            </table>
            <div className="table-wrapper-notes">
              <div className="table-wrapper-note">
                <div className="table-wrapper-note-title">
                  <span>
                    * студенты очной формы обучения по инженерным, ИТ и
                    естественно-научным направлениям
                  </span>
                </div>
              </div>
              <div className="table-wrapper-note">
                <div className="table-wrapper-note-title">
                  <span>
                    **отраслевые направления: 09. Информатика и вычислительная
                    техника; 15. Машиностроение; 27. Управление в технических
                    системах; 14. Ядерная энергетика и технологии; 02.
                    Компьютерные и информационные науки
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container cols2">
        {renderTable(vectorsTableData)}
        {/* мб понадобится */}
        {/* <CompareGraphs data={cmpData} cols="two-cols" /> */}
      </div>

      <div className="container cols2">
        {renderTable(vectorsEduTableData)}
        {/* мб понадобится */}
        {/* <CompareGraphs data={cmpData2} /> */}
      </div>

      <div className="container cols2">
        <TargetModelTable />
      </div>

      <div className="container cols2">
        <EngineeringOutputTable />
      </div>

      <div className="container cols2"></div>

    </section>
  );
}
